.RadioQuestion {
    .RadioAnswer {
        display: flex;
        align-items: flex-start;
        margin-top: 0.5rem;

        input[type='radio'] {
            margin-right: 0.5rem;
            flex-shrink: 0;
            margin-top: 0.25rem;
        }
    }
}
